import { useSelector } from "react-redux";
import { RootState } from "State/store";

export const useCartState = () =>
  useSelector((state: RootState) => state.cart);
